/* Replacement arms collection page: filter the cards by Falcon series.
   Cards carry data-series from their series:* tags (falcx-product-card). Without JS every arm shows and the filter bar
   stays hidden.

   Which series the page shows (r7):
   1. ?series= in the link (a hub, a search result, a shared link) always wins.
   2. Else, if the shopper chose "Show all Falcons" (button or "All Falcons" in the dropdown) earlier in this visit, all.
      That choice is kept in sessionStorage (falcx-arms-show-all-v1) for this tab until they pick a series again, so a
      reload, the back button or coming back from a product page does not quietly filter the list again.
   3. Else the saved vehicle's series ("my vehicle"), and the list follows it if it changes.
   4. Else all.
   Picking the saved vehicle's own series (dropdown or "Only my BA–BF") is rule 3 again: ?series= is dropped and the
   show-all choice is forgotten. Picking any other series puts it in ?series=. Nothing here changes the saved vehicle. */
(function () {
  'use strict';
  var ALL_KEY = 'falcx-arms-show-all-v1';
  function norm(value) {
    value = String(value || '').toLowerCase();
    return value === 'fg-x' ? 'fgx' : value === 'fg-fgx' ? 'fg' : value === 'ea-el' ? 'ea-ed' : value;
  }
  /* The saved vehicle's series when the page lists it, else null. */
  function mineOf(saved, values) {
    return saved && saved.series && values.indexOf(saved.series) !== -1 ? saved.series : null;
  }
  /* How the page starts: {mode: 'url' | 'all' | 'saved', value}. */
  function start(search, values, showAll, saved) {
    var fromUrl = norm(new URLSearchParams(search || '').get('series'));
    if (fromUrl && fromUrl !== 'all' && values.indexOf(fromUrl) !== -1) return {mode: 'url', value: fromUrl};
    if (showAll) return {mode: 'all', value: 'all'};
    return {mode: 'saved', value: mineOf(saved, values) || 'all'};
  }
  /* A choice made on this page: the mode it puts the page in. */
  function choose(value, values, saved) {
    if (value === 'all' || values.indexOf(value) === -1) return {mode: 'all', value: 'all'};
    if (value === mineOf(saved, values)) return {mode: 'saved', value: value};
    return {mode: 'url', value: value};
  }
  /* What the address bar says for a state: ?series= only for a series picked by hand that is not the saved one. */
  function addressFor(href, state) {
    var url = new URL(href);
    if (state.mode === 'url') url.searchParams.set('series', state.value); else url.searchParams.delete('series');
    return url.pathname + url.search + url.hash;
  }
  /* The two quick controls beside the dropdown. */
  function controls(value, mine) {
    return {showAll: value !== 'all', onlyMine: !!mine && value !== mine};
  }
  function statusText(value, shown, name) {
    var arms = shown === 1 ? '1 arm' : shown + ' arms';
    if (value === 'all') return 'Showing arms for all Falcons, ' + arms + '.';
    return shown ? 'Showing arms for ' + name + ', ' + arms + '.' : 'No arms listed for ' + name + ' yet.';
  }
  /* The vehicle the rest of the site should show while this series is on screen (falcx-finder's own rule for ?series=):
     the saved vehicle when it is that series, else that series' sedan. Null: no series in the address, so the finder
     falls back to the saved vehicle by itself. */
  function browsingFor(state, saved, knownSeries) {
    if (state.mode !== 'url' || knownSeries.indexOf(state.value) === -1) return null;
    return {series: state.value, body: saved && saved.series === state.value ? saved.body : 'sedan'};
  }
  var core = {norm: norm, mineOf: mineOf, start: start, choose: choose, addressFor: addressFor, controls: controls, statusText: statusText, browsingFor: browsingFor, ALL_KEY: ALL_KEY};
  if (typeof module !== 'undefined' && module.exports) module.exports = core;
  if (typeof document === 'undefined') return;

  function saved() {
    return window.FalcxVehicle && window.FalcxVehicle.getSaved ? window.FalcxVehicle.getSaved() : null;
  }
  function readAll() { try { return window.sessionStorage.getItem(ALL_KEY) === '1'; } catch (e) { return false; } }
  function writeAll(on) {
    try { if (on) window.sessionStorage.setItem(ALL_KEY, '1'); else window.sessionStorage.removeItem(ALL_KEY); } catch (e) { /* private mode: the choice lasts until reload */ }
  }
  /* Tell the vehicle line and the "Fits your …" ticks which vehicle is on show now that the address changed.
     Never saves anything. */
  function syncVehicle(state) {
    var api = window.FalcxVehicle;
    if (!api || !api.render) return;
    var known = (api.vehicles || []).map(function (v) { return v.series; });
    var next = browsingFor(state, api.getSaved(), known);
    if (next && api.setBrowsing && api.setBrowsing(next)) return; /* renders and emits falcx:browsing-change */
    api.render();
    document.dispatchEvent(new CustomEvent('falcx:browsing-change', {detail: {saved: api.getSaved(), browsing: api.getBrowsing ? api.getBrowsing() : null, active: api.getActive ? api.getActive() : null}}));
  }
  function setup(root) {
    if (root.dataset.armsReady) return;
    var select = root.querySelector('[data-arms-series]');
    var bar = root.querySelector('[data-arms-bar]');
    if (!select || !bar) return;
    root.dataset.armsReady = 'true';
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-arms-list] .falcx-pcard'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-arms-group]'));
    var status = root.querySelector('[data-arms-status]');
    var empty = root.querySelector('[data-arms-empty]');
    var emptyName = root.querySelector('[data-arms-empty-name]');
    var showAllButton = root.querySelector('[data-arms-show-all]');
    var mineButton = root.querySelector('[data-arms-use-saved]');
    var mineName = root.querySelector('[data-arms-mine-name]');
    var soonBox = root.querySelector('.falcx-arms__soon');
    var values = Array.prototype.map.call(select.options, function (option) { return option.value; });
    function nameOf(value) {
      var option = Array.prototype.find.call(select.options, function (o) { return o.value === value; });
      return option ? option.dataset.name || option.textContent : '';
    }
    var state;
    function renderControls() {
      var mine = mineOf(saved(), values);
      var show = controls(state.value, mine);
      if (showAllButton) showAllButton.hidden = !show.showAll;
      if (mineButton) {
        mineButton.hidden = !show.onlyMine;
        if (show.onlyMine && mineName) mineName.textContent = nameOf(mine);
      }
      bar.classList.toggle('has-actions', show.showAll || show.onlyMine);
    }
    function paint() {
      var value = state.value;
      if (select.value !== value) select.value = value;
      var shown = 0;
      cards.forEach(function (card) {
        var list = card.dataset.series ? card.dataset.series.split(',') : null;
        var on = value === 'all' || !list || list.indexOf(value) !== -1;
        card.hidden = !on;
        card.style.display = on ? '' : 'none';
        if (on) shown += 1;
      });
      groups.forEach(function (group) {
        var count = Array.prototype.filter.call(group.querySelectorAll('.falcx-pcard'), function (card) { return !card.hidden; }).length;
        group.hidden = count === 0;
        var badge = group.querySelector('[data-arms-count]');
        if (badge) badge.textContent = String(count);
      });
      var name = nameOf(value);
      if (status) status.textContent = statusText(value, shown, name);
      if (empty) empty.hidden = shown > 0;
      if (emptyName) emptyName.textContent = name;
      /* r8 sweep: "Prices coming soon" only while an arm on show has no price (it read as if every listed arm was unpriced). */
      if (soonBox) {
        var anySoon = cards.some(function (card) { return !card.hidden && card.hasAttribute('data-price-soon'); });
        soonBox.hidden = !anySoon;
        soonBox.style.display = anySoon ? '' : 'none';
      }
      renderControls();
    }
    /* A choice on this page: remember it for the visit, update the address without a reload, follow the vehicle line. */
    function pick(value) {
      state = choose(value, values, saved());
      writeAll(state.mode === 'all');
      var next = addressFor(window.location.href, state);
      if (next !== window.location.pathname + window.location.search + window.location.hash) history.replaceState(history.state, '', next);
      paint();
      syncVehicle(state);
    }
    state = start(window.location.search, values, readAll(), saved());
    bar.hidden = false;
    paint();
    select.addEventListener('change', function () { pick(select.value); });
    /* The control that was tapped goes away; move focus to the one that takes its place (or the dropdown), so
       keyboard and screen-reader users are not dropped at the top of the page. */
    if (showAllButton) showAllButton.addEventListener('click', function () {
      pick('all');
      (mineButton && !mineButton.hidden ? mineButton : select).focus();
    });
    if (mineButton) mineButton.addEventListener('click', function () {
      var mine = mineOf(saved(), values);
      if (!mine) return;
      pick(mine);
      (showAllButton && !showAllButton.hidden ? showAllButton : select).focus();
    });
    /* The saved vehicle can arrive after this ran (script order) or be changed in the vehicle dialog: follow it while
       the page is on "my vehicle"; otherwise only the "Only my …" control changes. */
    document.addEventListener('falcx:vehicle-change', function () {
      if (state.mode === 'saved') {
        var value = mineOf(saved(), values) || 'all';
        if (value !== state.value) { state = {mode: 'saved', value: value}; paint(); return; }
      }
      renderControls();
    });
    /* Back/forward cache: another tab or page may have changed the show-all choice or the vehicle. */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      state = start(window.location.search, values, readAll(), saved());
      paint();
    });
  }
  function init() { document.querySelectorAll('[data-falcx-arms]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();